import types from './types';
import { RESET_DETAILS } from '../genericDetails/types';

const defaultState = {
  locationList: [],
  buildingsList: [],
  isLoading: false,
  watershedId: null,
  experiment: null,
  isLoadingLocationList: false
};

export default (
  state = defaultState,
  {
    type,
    params,
    request /* using takeQuery: the initier action is set here */,
    data /* using takeQuery: query result will be set here */,
    ...action
  }
) => {
  switch (type) {
    case types.GET_LOCATION_AUTOCOMPLETE_LIST:
      return { ...state, isLoadingLocationList: true };
    case types.GET_LOCATION_AUTOCOMPLETE_LIST_SUCCESS:
      if (request.params.onlyBuildings)
        return { ...state, buildingList: data, isLoadingLocationList: false };
      else return { ...state, locationList: data, isLoadingLocationList: false };
    case types.GET_LOCATION_AUTOCOMPLETE_LIST_FAILURE:
      return { ...state, isLoadingLocationList: false };

    case types.GET_BUILDING_SUMMARY:
      return { ...state, isLoading: true };
    case types.GET_BUILDING_SUMMARY_SUCCESS:
      return { ...state, summary: data, isLoading: false };
    case types.GET_BUILDING_SUMMARY_FAILURE:
      return { ...state, isLoading: false };

    case types.GET_WATERSHED_ID_BY_LOCATION:
      return { ...state, isLoading: true };
    case types.GET_WATERSHED_ID_BY_LOCATION_SUCCESS:
      return { ...state, watershedId: data, isLoading: false };
    case types.GET_WATERSHED_ID_BY_LOCATION_FAILURE:
      return { ...state, isLoading: false };

    case types.GET_WATERSHED_BY_LOCATION:
      return { ...state, isLoading: true };
    case types.GET_WATERSHED_BY_LOCATION_SUCCESS:
      return { ...state, watershed: data, isLoading: false };
    case types.GET_WATERSHED_BY_LOCATION_FAILURE:
      return { ...state, isLoading: false };

    case types.GET_EXPERIMENT_BY_LOCATION:
      return { ...state, isLoading: true };
    case types.GET_EXPERIMENT_BY_LOCATION_SUCCESS:
      return { ...state, experiment: data, isLoading: false };
    case types.GET_EXPERIMENT_BY_LOCATION_FAILURE:
      return { ...state, isLoading: false };

    case types.SAVE:
      return { ...state, isLoading: true };
    case types.SAVE_SUCCESS:
    case types.SAVE_FAILURE:
      return { ...state, isLoading: false };

    case types.RESET_BUILDING_SUMMARY:
      return { ...state, summary: null };

    case RESET_DETAILS:
      return { ...state, watershedId: null, experiment: null };

    default:
      return state;
  }
};
